
import request from './index'
let projectId = 5
// 获取顶部导航
export const enCodeByPhone = () => {
  return request({
    url: '/website/enCodeByPhone',
    method: 'get',
    params: { projectId }
  })
}

// 获取首页相关
export const getHome = (parameterKey) => {
  return request({
    url: '/website/webParameter',
    method: 'get',
    params: { projectId,parameterKey }
  })
}

// 获取轮播图

export const carousel = () => {
  return request({
    url: '/website/carousel',
    method: 'get',
    params: { projectId }
  })
}
  //获取首页往届回顾
  export const reviewArticle = () => {
    return request({
      url: '/website/reviewArticle',
      method: 'get',
      params: { projectId }
    })
  }
  //获取首页展会图片
  export const exhibitionArticle = () => {
    return request({
      url: '/website/exhibitionArticle',
      method: 'get'
    })
  }
 
  //获取文章内容
  export const articleDetails = (articleId) => {
    return request({
      url: '/website/articleDetails',
      method: 'get',
      params: { articleId }
    })
  }
  //模糊查询文章
  export const articleSearch = (keyword) => {
    return request({
      url: '/website/articleSearch',
      method: 'get',
      params: { projectId,keyword }
    })
  }
  //获取首页行业动态
  export const industryArticle = () => {
    return request({
      url: '/website/industryArticle',
      method: 'get',
      params: { projectId }
    })
  }
  //动态列表
  export const articleList=(pageNum,pageSize,module)=>{
    return request({
      url: '/website/articleList',
      method: 'get',
      params: { projectId,pageNum,pageSize,module }
    })
  }
  //品牌logo
  export const brand=()=>{
    return request({
      url: '/website/brand',
      method: 'get',
      params: { projectId }
    })
  }
  //动态列表
  export const fileList=(pageNum,pageSize,fileType)=>{
    return request({
      url: '/website/fileList',
      method: 'get',
      params: { projectId,pageNum,pageSize,fileType}
    })
  }
  //登记提交
  export const registrationSubmit=(data)=>{
    return request({
      url: '/website/registrationSubmit',
      method: 'post',
      data
    })
  }
  

   //关于我们
   export const feedback=(data)=>{
    return request({
      url: '/website/feedback',
      method: 'post',
      data
    })
  }

  //合作媒体
  

  export const getmediaLink=(data)=>{
    return request({
      url: '/website/mediaLink',
      method: 'get',
      data
    })
  }



// WEBPACK FOOTER //
// ./src/api/api.js